interface GrassAtlasToolIllustrationProps {
  className?: string
}

/**
 * A compact cutaway specimen mark for Grass Atlas entry points.
 * The blades, soil block, roots, anatomy pins, and orbit line communicate the
 * product more clearly than a generic tool or scan icon.
 */
export function GrassAtlasToolIllustration({ className }: GrassAtlasToolIllustrationProps) {
  return (
    <svg
      viewBox="0 0 144 112"
      fill="none"
      className={className}
      aria-hidden="true"
      data-grass-atlas-tool-illustration
    >
      <path
        d="M16 43C24 15 50 5 76 8c25 3 45 16 52 38"
        stroke="#86B997"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="4 6"
      />
      <path d="m126 39 4 8-9-1" stroke="#86B997" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

      <path d="m22 54 47-18 53 17-47 19-53-18Z" fill="#B4874D" />
      <path d="m22 54 53 18v29L22 82V54Z" fill="#9A6D3D" />
      <path d="m75 72 47-19v29l-47 19V72Z" fill="#754E2F" />
      <path d="m25 55 44-16 49 15-43 16-50-15Z" fill="#6AA45E" />
      <path d="m28 56 42-15 44 14-40 14-46-13Z" fill="#86BC72" />

      <path d="M69 58C62 45 57 29 59 10c12 13 16 31 15 48" fill="#2E7D4A" />
      <path d="M73 58C72 39 77 20 88 7c1 22-4 39-10 52" fill="#49A65F" />
      <path d="M68 59C55 49 46 37 42 22c14 7 25 21 31 37" fill="#6BBE68" />
      <path d="M79 60c7-15 18-27 32-34-4 16-13 28-28 36" fill="#287A42" />
      <path d="M64 58c-12-5-22-12-29-23 14 2 27 10 35 21" fill="#8DCC72" />
      <path d="M81 59c13-5 23-12 31-21-2 13-12 23-27 28" fill="#56AE56" />

      <path d="M66 67c-4 9-10 15-17 21M72 68c-1 11-4 19-8 27M79 67c3 10 8 17 15 24M83 65c8 7 15 12 24 15M71 77l-10 4M80 77l10 3"
        stroke="#E7C98E"
        strokeWidth="2"
        strokeLinecap="round"
      />

      <g stroke="#F8FFF9" strokeWidth="2">
        <circle cx="43" cy="28" r="8" fill="#155D36" />
        <circle cx="105" cy="22" r="8" fill="#155D36" />
        <circle cx="101" cy="76" r="8" fill="#155D36" />
      </g>
      <path d="M43 25v6M40 28h6M105 19v6M102 22h6M101 73v6M98 76h6" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  )
}
